import { createSelector } from 'reselect';
import { PapiGallection } from '@wix/da-papi-types';
import {
  getHasMoreInDirection,
  getItems,
} from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { AppState } from '../types/store';
import {
  STASH_FOLDER_DEVIATIONS_STREAM,
  STASH_SUBFOLDERS_STREAM,
} from '../../constants';

export function getStashFolder(state: AppState) {
  return state.stash?.folder;
}

export const getFolderDeviations = (state: AppState) =>
  getItems(state, STASH_FOLDER_DEVIATIONS_STREAM.streamId);

export const getHasDeviations = createSelector(
  [getFolderDeviations],
  deviations => deviations.length > 0
);

export const getSubfolders = (state: AppState) =>
  getItems<PapiGallection>(state, STASH_SUBFOLDERS_STREAM.streamId);

export const getVisibleSubfolders = (state: AppState) =>
  (getSubfolders(state) || []).filter(f => !f.isHidden);

export const getHasSubfolders = createSelector([getSubfolders], subfolders =>
  (subfolders ?? []).some(f => !f.isHidden)
);

export const getHasMoreSubfolders = (state: AppState) =>
  getHasMoreInDirection(state, STASH_SUBFOLDERS_STREAM.streamId, 'next');

export function getIsVisitorView(state: AppState) {
  return !!state.stash?.isVisitorView;
}
